import { CommonModule, NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  Input,
  OnInit,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  AngularDatasModule,
  AuthService,
  MessageMetaService,
} from '@univacity/angular/datas';
import {
  AngularUiModule,
  ColorSchemeService,
  DestroyAbleComponent,
  Menu,
} from '@univacity/angular/ui';
import { RoutePath } from '@univacity/shared/types';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDrawerRef, NzDrawerService } from 'ng-zorro-antd/drawer';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { takeUntil } from 'rxjs';
import { CurrencyNavComponent } from '../currency-nav/currency-nav.component';
import { getDasboardMenu } from '../dashboard-menu';
import { mainMenu } from '../main-menu';
import { ThemeSwitcherComponent } from '../theme-switcher/theme-switcher.component';
import { SearchDrawerComponent } from '../search-drawer/search-drawer.component';

@Component({
  selector: 'un-mobile-menu',
  imports: [
    CommonModule,
    RouterModule,
    AngularUiModule,
    AngularDatasModule,
    NgOptimizedImage,
    NzTabsModule,
    NzCollapseModule,
    CurrencyNavComponent,
    ThemeSwitcherComponent,
    NzBadgeModule,
  ],
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileMenuComponent
  extends DestroyAbleComponent
  implements OnInit
{
  @Input() mainMenu: Menu[] = mainMenu;
  @Input() dashboardMenu: Menu[] = [];
  layout = 'light';
  RoutePath = RoutePath;
  messageCount = 0;
  openMap: { [name: string]: boolean } = {
    sub1: true,
    sub2: false,
    sub3: false,
  };

  constructor(
    private colorScheme: ColorSchemeService,
    public auth: AuthService,
    private cdr: ChangeDetectorRef,
    private messageMeta: MessageMetaService,
    private drawerService: NzDrawerService,
    private drawer: NzDrawerRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.setupLayout();
    if (this.auth.isLoggedIn) {
      this.messageMeta.countUserUnread().subscribe((c) => {
        this.messageCount = c;
        this.cdr.detectChanges();
      });
    }
    this.dashboardMenu = getDasboardMenu(this.auth);
    this.cdr.detectChanges();
  }

  openSearchDrawer() {
    this.drawerService.create({
      nzTitle: $localize``,
      nzContent: SearchDrawerComponent,
      nzContentParams: {},
      nzPlacement: 'top',
      nzMaskClosable: true,
      nzWidth: '100%',
    });
  }

  setupLayout() {
    this.colorScheme.init();
    this.layout = this.colorScheme.currentActive();
    this.colorScheme.theme$.pipe(takeUntil(this.dead$)).subscribe((theme) => {
      this.layout = theme;
      this.cdr.detectChanges();
    });
  }

  close() {
    this.drawer.close();
  }
  logout() {
    this.auth.logout();
    this.drawer.close();
  }
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  @HostListener('click', ['$event']) onClick($e: Event) {
    $e.stopPropagation();
  }
}
